import React, { useState, useCallback, useContext } from "react";
import EmailLoginForm from "../components/modules/EmailLoginForm";
import ApiService from "../services/ApiService";
import history from "../services/history";
import LoadingIndicator from "../components/modules/LoadingIndicator";
import AlertContext from "../contexts/AlertContext";

export interface LoginPageProps {
  onSignIn(): void;
}

function LoginPage(props?: LoginPageProps) {
  const apiService = useCallback(() => new ApiService(), []);
  const { setAlert } = useContext(AlertContext);
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUserLogin = async (email: string, password: string) => {
    setAlert(null);
    setLoading(true);
    setUsername(email);
    const response = await apiService().signIn({
      user: email,
      pass: password,
      authType: "CustomerEmail",
    });
    if (response.signedIn) {
      setLoading(false);

      if (props?.onSignIn) {
        props.onSignIn();
      }

      history.push("/");
    } else {
      setAlert(response);
      setLoading(false);
    }
  };

  if (loading) return <LoadingIndicator loading={loading} />;

  return (
    <div className="grid grid-cols-12 mt-10">
      <section className="p-3 col-start-2 col-span-10 lg:col-start-5 lg:col-span-4 bg-gray-950 text-white rounded-md">
        <div className="text-lg text-center w-full">E911 Management</div>
        <div>
          <EmailLoginForm
            email={username}
            onSubmit={(email, password) => handleUserLogin(email, password)}
          />
        </div>
      </section>
    </div>
  );
}

export default LoginPage;
